import { IApiEpUserAuthorized } from "@smp/api";
import {
  REACT_APP__BASE_PATH,
  REACT_APP__BILLING_POLICY_REDIRECT_ENABLED,
  storeEp,
} from "@smp/utils";
import { matchPath } from "react-router-dom";

export const SESSION_DRAG_TOKEN_PARAM = "session_drag_token";

export const redirector = {
  clearNext: () => {
    storeEp.set("auth_next_url", null);
  },

  getAppPathname: (pathname?: string, isAbsolute?: boolean) => {
    pathname = pathname || window.location.pathname;

    if (REACT_APP__BASE_PATH) {
      const re = new RegExp(`^${REACT_APP__BASE_PATH}`);

      pathname = pathname.replace(re, "");

      if (isAbsolute) {
        pathname = `${REACT_APP__BASE_PATH}${pathname}`;
      }
    }

    return pathname;
  },

  getAuthLocation: (next?: string) => {
    const { pathname, search } = window.location;
    const sp = new URLSearchParams(search);
    const paramUtmCampaign = sp.get("utm_campaign");

    next = next || `${redirector.getAppPathname(pathname)}${search || ""}`;

    if (paramUtmCampaign === "canvas") {
      next = redirector.getAppPathname("/polotno/templates") || undefined;
    }

    const nextIsPolotnoTemplate = Boolean(
      next && matchPath(next, "/polotno/templates/:id"),
    );

    return {
      pathname: nextIsPolotnoTemplate ? "/auth/signup" : "/auth/signin",
      state: {
        next,
      },
    };
  },

  getCrossDomainRedirectLocation: (
    user: Pick<
      IApiEpUserAuthorized,
      "assigned_site_auth_token" | "assigned_site_host"
    >,
    pathname?: string,
  ) => {
    if (!REACT_APP__BILLING_POLICY_REDIRECT_ENABLED) {
      return undefined;
    }

    const next = redirector.getNext(true);
    const token = user.assigned_site_auth_token;
    const hostnameTarget = user.assigned_site_host;
    const hostnameCurrent = window.location.hostname;

    if (hostnameCurrent !== hostnameTarget) {
      const sp = new URLSearchParams(
        next ? next.match(/\?(.*)/g)?.[0] : undefined,
      );

      if (token) {
        sp.set(SESSION_DRAG_TOKEN_PARAM, token);
      }

      if (next) {
        sp.set("next", next);
      }

      return `${window.location.protocol}//${hostnameTarget}${
        pathname || next || `${REACT_APP__BASE_PATH}/` || ""
      }${sp.size ? "?" + sp.toString() : ""}`;
    }
  },

  getEmailVerificationLocation: () => {
    const authLocation = redirector.getAuthLocation();

    return {
      ...authLocation,
      pathname: "/email_verification",
    };
  },

  getNext: (isAbsolute?: boolean) => {
    const next = storeEp.get("auth_next_url");

    return next && redirector.getAppPathname(next, isAbsolute);
  },

  getNextSection: () => {
    const next = redirector.getNext();

    return next && next.replace(/^\/([^/]*).*$/, "$1");
  },

  saveNext: (value: string | null) => {
    storeEp.set("auth_next_url", value || null);
  },
};
